export const TYPES = {	
    SAVE_TABLE_SELECTIONS: 'SAVE_TABLE_SELECTIONS',
    UPDATE_TABLE_SELECTIONS: 'UPDATE_TABLE_SELECTIONS',
    RESET_TABLE_SELECTIONS: 'RESET_TABLE_SELECTIONS',
}